var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var CHAT_URL = 'https://qaa.priceline.com/cart/checkout/usp/st/travelChat';
/**
 * fetchChatStream
 * fetch module to handle stream response from openai api
 * @public
 */
export var fetchChatStream = function (_a) {
    var submitChatMessagesPayload = _a.submitChatMessagesPayload, url = _a.url, headers = _a.headers, setStreamingText = _a.setStreamingText;
    return __awaiter(void 0, void 0, void 0, function () {
        var res, reader, result, response, text, err_1, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 12, , 13]);
                    return [4 /*yield*/, fetch(url || CHAT_URL, {
                            method: 'POST',
                            body: JSON.stringify(submitChatMessagesPayload),
                            keepalive: true,
                            headers: __assign({ 'Content-Type': 'application/json', accept: 'text/event-stream', 'Cache-Control': 'no-cache' }, headers),
                        })];
                case 1:
                    res = _b.sent();
                    if (res.status !== 200) {
                        throw Error("".concat(res.status, ": ").concat(res.statusText));
                    }
                    if (!(res.body && res.body.getReader)) return [3 /*break*/, 10];
                    reader = res.body.getReader();
                    _b.label = 2;
                case 2:
                    if (!true) return [3 /*break*/, 9];
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 7, , 8]);
                    return [4 /*yield*/, reader.read()];
                case 4:
                    result = _b.sent();
                    if (result === null || result === void 0 ? void 0 : result.done) {
                        setStreamingText('STREAMING_ENDED');
                        return [2 /*return*/, {
                                isOk: true,
                            }];
                    }
                    if (!(result === null || result === void 0 ? void 0 : result.value)) return [3 /*break*/, 6];
                    response = new Response(result.value);
                    return [4 /*yield*/, response.text()];
                case 5:
                    text = _b.sent();
                    setStreamingText(text.replace(/\0/g, '')); // remove null in string
                    _b.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    err_1 = _b.sent();
                    return [2 /*return*/, {
                            isOk: false,
                            errorCode: 'READER_READ_ERROR',
                            errorMessage: err_1 === null || err_1 === void 0 ? void 0 : err_1.message,
                        }];
                case 8: return [3 /*break*/, 2];
                case 9: return [3 /*break*/, 11];
                case 10: return [2 /*return*/, {
                        isOk: false,
                        errorCode: 'NOT_SUPPORTED',
                        errorMessage: 'ReadableStream not supported',
                    }];
                case 11: return [3 /*break*/, 13];
                case 12:
                    err_2 = _b.sent();
                    setStreamingText('STREAMING_ENDED');
                    return [2 /*return*/, {
                            isOk: false,
                            errorCode: 'ERROR',
                            errorMessage: err_2 === null || err_2 === void 0 ? void 0 : err_2.message,
                        }];
                case 13: return [2 /*return*/];
            }
        });
    });
};
/**
 * submitChatMessages
 * post give message
 * @public
 */
export var submitChatMessages = function (_a) {
    var handleMarkerResponse = _a.handleMarkerResponse, submitChatMessagesPayload = _a.submitChatMessagesPayload, 
    // Local state control
    chatMessages = _a.chatMessages, setChatMessage = _a.setChatMessage, setPrompts = _a.setPrompts, setStreamingText = _a.setStreamingText, setLoadingStatus = _a.setLoadingStatus, setErrorMessage = _a.setErrorMessage, 
    // Cache control
    _b = _a.cacheControl, setCachedMessages = _b.setCachedMessages, setCachedPrompts = _b.setCachedPrompts, 
    // Request options
    _c = _a.requestOptions, _d = _c.url, url = _d === void 0 ? '' : _d, _e = _c.headers, headers = _e === void 0 ? {} : _e, _f = _a.markerComponentsKeys, markerComponentsKeys = _f === void 0 ? [] : _f;
    return __awaiter(void 0, void 0, void 0, function () {
        var isMarkerInResponse, isJsonMarker, foundMarker, longestKeyLength, fullTexts, result, fullResultString, _g, role, content, messageContent, promptContent, _h, markerComponentProps, chatMessage, promptMessage, msg, rollbackChatMessages;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    setLoadingStatus(true); // display loading
                    setErrorMessage(''); // remove error message
                    isMarkerInResponse = false;
                    isJsonMarker = false;
                    foundMarker = '';
                    longestKeyLength = markerComponentsKeys.reduce(function (len, key) {
                        if (key.length > len) {
                            len = key.length;
                        }
                        return len;
                    }, 0);
                    fullTexts = [];
                    return [4 /*yield*/, fetchChatStream({
                            submitChatMessagesPayload: submitChatMessagesPayload,
                            url: url,
                            headers: headers,
                            setStreamingText: function (text) {
                                if (text !== 'STREAMING_ENDED') {
                                    fullTexts.push(text);
                                    var fullText_1 = fullTexts.join('');
                                    if (fullText_1.length >= longestKeyLength) {
                                        foundMarker = markerComponentsKeys.find(function (key) { return fullText_1.includes(key); });
                                        isJsonMarker = foundMarker && foundMarker.startsWith('JSONOBJECT');
                                        if (isJsonMarker && !isMarkerInResponse) {
                                            isMarkerInResponse = true;
                                            var markerIndex = fullText_1.indexOf(foundMarker);
                                            setStreamingText(fullText_1.substring(0, markerIndex));
                                        }
                                        if (foundMarker && !isJsonMarker && !isMarkerInResponse && handleMarkerResponse) {
                                            isMarkerInResponse = true;
                                            var _a = handleMarkerResponse(null, foundMarker, fullText_1), role = _a.role, content = _a.content, messageContent = _a.messageContent, promptContent = _a.promptContent, _b = _a.markerComponentProps, markerComponentProps = _b === void 0 ? {} : _b;
                                            // Message display to the user
                                            var chatMessage = { role: role, content: messageContent || content, markerComponentProps: markerComponentProps };
                                            setChatMessage(__spreadArray(__spreadArray([], chatMessages, true), [chatMessage], false));
                                            // Message send to the bot API
                                            var promptMessage = { role: role, content: promptContent || content };
                                            setPrompts(__spreadArray(__spreadArray([], submitChatMessagesPayload.prompts, true), [promptMessage], false));
                                            setCachedMessages(chatMessage);
                                            setCachedPrompts(promptMessage);
                                            setLoadingStatus(false);
                                        }
                                        if (!foundMarker) {
                                            var splittedFullTextByLine = fullText_1.substring(fullText_1.length - longestKeyLength).split('\n');
                                            var lastLine = splittedFullTextByLine[splittedFullTextByLine.length - 1];
                                            var splittedLineBySpace = lastLine.split(' ');
                                            var lastWord_1 = (splittedLineBySpace === null || splittedLineBySpace === void 0 ? void 0 : splittedLineBySpace[splittedLineBySpace.length - 1]) || '';
                                            var isContainingPartialMarker = markerComponentsKeys.find(function (key) { return key.includes(lastWord_1); });
                                            if (!isContainingPartialMarker) {
                                                // Display streaming text
                                                setStreamingText(fullText_1);
                                            }
                                        }
                                    }
                                }
                                else {
                                    // Clear live streaming text, when streaming ends
                                    setStreamingText('');
                                }
                            },
                        })];
                case 1:
                    result = _j.sent();
                    if (isJsonMarker && handleMarkerResponse) {
                        isMarkerInResponse = true;
                        if ((result === null || result === void 0 ? void 0 : result.isOk) && fullTexts.length !== 0) {
                            fullResultString = fullTexts.join('');
                            _g = handleMarkerResponse(null, foundMarker, fullResultString), role = _g.role, content = _g.content, messageContent = _g.messageContent, promptContent = _g.promptContent, _h = _g.markerComponentProps, markerComponentProps = _h === void 0 ? {} : _h;
                            chatMessage = { role: role, content: messageContent || content, markerComponentProps: markerComponentProps };
                            promptMessage = { role: role, content: promptContent || content };
                            setChatMessage(__spreadArray(__spreadArray([], chatMessages, true), [chatMessage], false));
                            setPrompts(__spreadArray(__spreadArray([], submitChatMessagesPayload.prompts, true), [promptMessage], false));
                            setCachedMessages(chatMessage);
                            setCachedPrompts(promptMessage);
                            setLoadingStatus(false);
                        }
                        return [2 /*return*/];
                    }
                    if (!isMarkerInResponse) {
                        if ((result === null || result === void 0 ? void 0 : result.isOk) && fullTexts.length !== 0) {
                            msg = {
                                role: 'assistant',
                                content: fullTexts.join(''),
                            };
                            setChatMessage(__spreadArray(__spreadArray([], chatMessages, true), [msg], false));
                            setPrompts(__spreadArray(__spreadArray([], submitChatMessagesPayload.prompts, true), [msg], false));
                            setLoadingStatus(false);
                            setCachedMessages(msg);
                            setCachedPrompts(msg);
                            return [2 /*return*/];
                        }
                        else if (!(result === null || result === void 0 ? void 0 : result.isOk)) {
                            if (chatMessages.length > 1) {
                                rollbackChatMessages = __spreadArray([], chatMessages.slice(0, chatMessages.length - 1), true);
                                setChatMessage(rollbackChatMessages);
                                setCachedMessages(null, rollbackChatMessages);
                            }
                            if (handleMarkerResponse) {
                                handleMarkerResponse(result, '');
                            }
                            setErrorMessage('Network error! Please check your network connection and retry.');
                            setLoadingStatus(false);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=submitChatMessages.js.map